





































































































import { Component, Emit, Prop, Ref, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { Col } from '@/components/molecules/DataTable'
import { cloneDeep } from 'lodash'
import { defaultDonor, Donor } from '@/api'
import { dataStore, donorStore } from '@/utils/store-accessor'
import { AtomTextField } from '@/components/atoms'

interface SelectDonor extends Donor {
  isSelected: boolean
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: 80,
    resizable: true,
    movable: false,
    items: [
      {
        name: 'code',
        headerText: 'code'
      }
    ]
  },
  {
    width: '70',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'name',
        headerText: '正式形'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'shortName',
        headerText: '省略形'
      }
    ]
  }
]

interface FilterCondition {
  code: string
  name: string
}

const defaultFilterCondition = (): FilterCondition => ({
  code: '',
  name: ''
})

@Component({
  components: {
    ModalFooter,
    DataTable
  }
})
export default class ModalDonor extends ModalComponentBaseVue {
  @Ref()
  codeTextField!: AtomTextField

  @Ref()
  nameTextField!: AtomTextField

  @Prop({
    type: Array
  })
  defaultCodes!: string[]

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  dialog: boolean = false

  isAllSelect: boolean = false

  tableBodyHeight: number = 0

  donors: SelectDonor[] = []

  filterCondition: FilterCondition = defaultFilterCondition()

  get cols(): Col[] {
    if (this.multiple) {
      const cols: Col[] = cloneDeep(COLS)
      cols[0].items[0].name = 'check'
      return cols
    }

    return COLS
  }

  // codeKeyが固定なのでcountも固定とする
  get codeMask(): string {
    return 'X'.repeat(4)
  }

  get countOfDonors(): number {
    return this.filteredDonors.length
  }

  get countOfSelectedDonors(): number {
    return this.filteredDonors.filter(donor => donor.isSelected).length
  }

  get filteredDonors(): SelectDonor[] {
    const codeRegExp = new RegExp(`^${this.filterCondition.code}`)
    const nameRegExp = new RegExp(`${this.filterCondition.name}`)

    return this.donors.filter(
      donor =>
        (this.filterCondition.code === '' || donor.code.match(codeRegExp)) &&
        (this.filterCondition.name === '' ||
          donor.name.match(nameRegExp) ||
          donor.shortName.match(nameRegExp))
    )
  }

  @Watch('filteredDonors')
  onFiltered(newVal: SelectDonor[]): void {
    this.donors.forEach(
      donor =>
        (donor.isSelected =
          donor.isSelected && newVal.some(value => value.code === donor.code))
    )

    if (!this.multiple && newVal.every(donor => !donor.isSelected)) {
      newVal.forEach(
        (trader: SelectDonor, index: number) =>
          (trader.isSelected = index === 0)
      )
    }
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    val ? this.opened() : this.closed()
  }

  @Watch('isAllSelect')
  toggleSelected(newVal: boolean): void {
    this.filteredDonors.forEach(donor => {
      donor.isSelected = newVal
    })
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.calculateTableHeight)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  open(): void {
    this.dialog = true
    this.$nextTick(() => {
      this.calculateTableHeight()
      setTimeout(this.focus)
    })
  }

  focus(): void {
    if (dataStore.systemCodeDialogInitialFocusName) {
      this.nameTextField.atomTextField.focus()
    } else {
      this.codeTextField.atomTextField.focus()
    }
  }

  close(): void {
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickOk(): void {
    this.$emit(
      'ok',
      this.multiple
        ? this.filteredDonors.filter(donor => donor.isSelected)
        : this.filteredDonors.find(donor => donor.isSelected) ?? defaultDonor()
    )
    this.close()
  }

  onClickCancel(): void {
    this.$emit('cancel')
    this.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-donor')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onRowClick(index: number): void {
    if (this.multiple) {
      this.filteredDonors[index].isSelected = !this.filteredDonors[index]
        .isSelected
      return
    }

    this.filteredDonors.forEach(
      donor => (donor.isSelected = donor.id === this.filteredDonors[index].id)
    )
  }

  onRowDblclick(): void {
    if (this.multiple) return
    this.onClickOk()
  }

  toggleAllSelect(val: boolean): void {
    this.isAllSelect = val
  }

  @Emit('opened')
  opened(): void {
    this.donors = donorStore.allItems.map((item, index) => {
      const existsCode: boolean = this.defaultCodes.some(
        code => code.trim() === item.code
      )
      return {
        ...item,
        // 空白があっても対応できるようにしている
        isSelected: this.multiple || existsCode ? existsCode : index === 0
      }
    })
  }

  @Emit('closed')
  closed(): void {
    this.donors = []
    this.isAllSelect = false
  }
}
